<template>
  <toaster @close-toaster="closeSummaryToaster">
    <template v-slot:text>
      <span>היעד החודשי שלך התעדכן</span>
    </template>
  </toaster>
</template>

<script>
import EventBus from '@/event-bus/event-bus';
import Toaster from '../../../../../../base-components/Toaster';

export default {
  name: 'RiseupGoalUpdatedToaster',
  components: {
    Toaster,
  },
  methods: {
    closeSummaryToaster() {
      EventBus.$emit('close-toaster');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
